export default "__VITE_PUBLIC_ASSET__0ae0ebba__"